// Resolves a server-built DetailUrl slug (e.g. "tpclientlink?ThirdPartyClientName=Acme") to an
// absolute app URL. content.js's load() resolves the slug from the address bar on mount, so this
// is a full-page navigation rather than in-app nav.
//
// A full reload per jump is the accepted v1 tradeoff (CD-5425): in-app link_click navigation would
// avoid it but needs a menuitem and icon resolved per hit, which is Phase 4 work. Do not build both.
export function pageHref(detailUrl: string): string {
  return `${window.location.origin}/${detailUrl}`;
}

export default pageHref;
